module.exports = __webpack_public_path__ + "static/media/a7.dc339f22.jpg";